export default __webpack_public_path__ + "static/media/GroupBig1749.f4e1fd18.svg";